import * as z from "zod";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

export const setWorkflowConnectorEnabled = mutator({
  description:
    "Enables or disables calls through a configured workflow connector.",
  interactionType: "update",
  schema: z.object({
    connectedAppId: z.string(),
    enabled: z.boolean(),
  }),
  resolve: { app: { kind: "connectedApp", from: "connectedAppId" } },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, args: { app, enabled } }) => {
    if (app.identifier !== "workflow" || !app.backingWorkflowId || app.fresh) {
      throw userFacingError("Finish setting up this workflow connector first.");
    }
    await tx.mutate.connectedApps.update({
      id: app.id,
      configuration: { ...app.configuration, enabled: String(enabled) },
    });
  },
});
